// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"84f09c61","80":"a685c007","134":"304ac4be","205":"92c4213a","210":"bd64bef0","253":"99ced520","411":"89fe957b","524":"53a502a7","658":"25721c42","661":"59a657fb","787":"69b45946","925":"27fbd05b"}[chunkId] + ".chunk.js";
};